module.exports = __webpack_public_path__ + "media/images/color_admin_v3/user-5-aaac6a82aa648a87ab9702d26a83c182.jpg";